var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_406_2187)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_406_2187",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.62 8.95C19.57 4.33 15.54 2.25 12 2.25C12 2.25 12 2.25 11.99 2.25C8.45997 2.25 4.41997 4.32 3.36997 8.94C2.19997 14.1 5.35997 18.47 8.21997 21.22C9.27997 22.24 10.64 22.75 12 22.75C13.36 22.75 14.72 22.24 15.77 21.22C18.63 18.47 21.79 14.11 20.62 8.95ZM12 13.96C10.26 13.96 8.84997 12.55 8.84997 10.81C8.84997 9.07 10.26 7.66 12 7.66C13.74 7.66 15.15 9.07 15.15 10.81C15.15 12.55 13.74 13.96 12 13.96Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.62 8.95C19.57 4.33 15.54 2.25 12 2.25C12 2.25 12 2.25 11.99 2.25C8.45997 2.25 4.41997 4.32 3.36997 8.94C2.19997 14.1 5.35997 18.47 8.21997 21.22C9.27997 22.24 10.64 22.75 12 22.75C13.36 22.75 14.72 22.24 15.77 21.22C18.63 18.47 21.79 14.11 20.62 8.95ZM12 13.96C10.26 13.96 8.84997 12.55 8.84997 10.81C8.84997 9.07 10.26 7.66 12 7.66C13.74 7.66 15.15 9.07 15.15 10.81C15.15 12.55 13.74 13.96 12 13.96Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1_406_2187)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_406_2187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.0e64b04a265041c99a5d9b1cc041b144.svg";
export { ForwardRef as ReactComponent };